module.exports = __webpack_public_path__ + "static/media/frown.1150984d.svg";